/* eslint-disable standard/no-callback-literal */
import auth from "@/modules/auth/services/auth";
import axios from "axios";
import router from "@/modules/global/router";
import store from "@/modules/global/stores";
// eslint-disable-next-line no-unused-vars

var http = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token"),
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    },
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        }),
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        }),
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                })
                .catch(function (err) {
                    var failedRequest = err.config;
                    // eslint-disable-next-line no-undef
                    var token = JSON.parse(localStorage.getItem("token")).value;
                    auth.doLogout(token, function (result) {
                        if (result.success) {
                            localStorage.clear();
                            store.commit("auth_destroyed");
                            router.push("/");
                        }
                    });

                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    },
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization: "Bearer " + JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function getListPeriode(pagination, search, callback) {
    var config = getConfig();

    http.get(
        "ambis-meter/admin/periode/list?page=" +
            pagination.page +
            "&size=" +
            pagination.size +
            "&name=" +
            search,
        config,
    )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addPeriode(data, callback) {
    var config = getConfig();

    http.post("ambis-meter/admin/periode", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updatePeriode(id, data, callback) {
    var config = getConfig();
    var param = {
        id: id,
        name: data.name,
        description: data.description,
        start_date: data.start_date,
        end_date: data.end_date,
        is_active: data.is_active,
    };

    http.put("ambis-meter/admin/periode/" + id, param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addMission(data, callback) {
    var config = getConfig();

    http.post("ambis-meter/admin/mission", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateMission(id, kelas, data, callback) {
    var config = getConfig();
    var kelas = kelas;
    var param = data;

    http.put("ambis-meter/admin/mission/" + id + "/" + kelas, param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addLevel(data, callback) {
    var config = getConfig();

    http.post("ambis-meter/admin/level-periode", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateLevel(id, kelas, data, callback) {
    var config = getConfig();
    var kelas = kelas;
    var param = data;

    http.put(
        "ambis-meter/admin/level-periode/" + id + "/" + kelas,
        param,
        config,
    )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getMissionDetail(id, callback) {
    var config = getConfig();

    http.get("ambis-meter/admin/mission/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getLevelDetail(id, callback) {
    var config = getConfig();

    http.get("ambis-meter/admin/level-periode/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getLeaderboard(id, kelas, callback) {
    var config = getConfig();

    var url = "ambis-meter/admin/leaderboard?periode=" + id + "&kelas=" + kelas;

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListQuote(pagination, callback) {
    var config = getConfig();

    var url =
        "ambis-meter/admin/quotes/list?page=" +
        pagination.page +
        "&size=" +
        pagination.size;

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getQuotesDetail(id, callback) {
    var config = getConfig();

    http.get("ambis-meter/admin/quote/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addQuotes(data, callback) {
    var config = getConfig();

    http.post("ambis-meter/admin/quote", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateQuotes(id, data, callback) {
    var config = getConfig();
    var param = {
        id: id,
        quote: data.quote,
        level_id: data.level_id,
    };

    http.put("/ambis-meter/admin/quote/" + id, param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getLevelList(callback) {
    var config = getConfig();

    http.get("ambis-meter/admin/level/list", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getInfo(callback) {
    var config = getConfig();

    http.get("ambis-meter/info", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    getListPeriode,
    addPeriode,
    updatePeriode,
    addMission,
    updateMission,
    addLevel,
    updateLevel,
    getLevelDetail,
    getMissionDetail,
    getLeaderboard,
    getListQuote,
    getQuotesDetail,
    addQuotes,
    updateQuotes,
    getLevelList,
    getInfo,
};



// WEBPACK FOOTER //
// ./src/modules/ambis_meter/services/ambis_meter.js